import {
    inject,
    Injectable,
} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {
    Observable,
    of,
} from 'rxjs';
import {
    catchError,
    map,
    switchMap,
    take,
    tap,
} from 'rxjs/operators';

import { AuthenticationService } from '~/app/core/services/api/authentication/authentication.service';
import { ConfigurationFacade } from '~/app/core/state/configuration/configuration.facade';

import { AuthenticationFacade } from '~/app/core/state/authentication/authentication.facade';

@Injectable({
    providedIn: 'root',
})
export class PublicAuthenticationGuard {
    private router = inject(Router);

    private authenticationFacade = inject(AuthenticationFacade);

    private configurationFacade = inject(ConfigurationFacade);

    private authenticationService = inject(AuthenticationService);

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.getUserData(state.url).pipe(
            switchMap((hasToken) => of(hasToken)),
            catchError(() => of(false)),
        );
    }

    public getUserData(targetUrl?: string): Observable<any> {
        // GUEST ALLOWED
        if (this.configurationFacade.getAuthenticationSnapshot()?.guestAllowed === true && !targetUrl?.includes('?tutorial')) {
            if (this.authenticationFacade.getTokenSnapshot() && !this.authenticationFacade.getUserNameSnapshot()) {
                return this.authenticationService.user().pipe(switchMap((user) => {
                    this.authenticationFacade.updateUser(user);
                    return of(true);
                }));
            }
            return of(true);
        }
        // GUEST FORBIDDEN
        return this.authenticationFacade.token$
            .pipe(
                tap((token: string | null | undefined) => {
                    if (!token) {
                        // Utilise l'URL cible passée en paramètre ou fallback sur router.url
                        const currentUrl = targetUrl || this.router.url;
                        this.router.navigate(['/auth/login'], {
                            queryParams: { redirect: currentUrl }
                        });
                    }
                }),
                map((token: string | null | undefined) => typeof token === 'string'),
                take(1),
            );
    }
}
